export default __webpack_public_path__ + "static/media/marleen_stueber_quadrat.1f0e51d8.png";